import React, { useCallback } from 'react';

import SingleSlider from '@/components/slider/singleSlider';

type Props = {
  /** Function accepting a value between 0 and 100 */
  onChange: (newVal: number) => void;
  value: number;
};

export const OpacityChanger: React.FC<Props> = ({ value, onChange }) => {
  const onValueChange = useCallback(
    (val) => {
      const newValue = val;

      onChange(newValue);
    },
    [onChange]
  );

  return (
    <SingleSlider
      liveUpdateValue
      defaultValue={value}
      handleChange={onValueChange}
      maxVal={100}
      minVal={0}
      showNumberInput={false}
    />
  );
};
